import { Injectable } from '@angular/core';
import { TreeNode } from './lib/tree-node';
import { MultiSetTreeBuilder } from './MultiSet/multi-set-tree-builder';
import { DefinitionKind } from '@angular/compiler/src/constant_pool';
import { MultiSetTreeNode } from './MultiSet/multi-set-tree-node';

@Injectable({
  providedIn: 'root'
})
/**
 * The service class Tree Service is responsible for 
 * storing all types of tree in a suitable storage format on a json file.
 * The class also provides functionality to restore stored trees.
 */
export class TreeService {


  exportTreeOld(treetype: string, alphabet: any[], depth: number, hasRepetition: boolean,
    definition: any) {

    definition.typespecifics = {};
    definition.typespecifics.treeType = treetype;
    definition.typespecifics.hasRepetition = hasRepetition;
    definition.typespecifics.depth = depth;

    //Export alphabet
    definition.typespecifics.alphabet = new Array();
    alphabet.forEach(element => {
      definition.typespecifics.alphabet.push(element);
    })
  }

  exportTree(tree:MultiSetTreeBuilder, definition: any, specAlreadyDefined?: boolean){
    this.exportMultiTree(tree, definition, specAlreadyDefined);
  }

  exportMultiTree(tree: MultiSetTreeBuilder, definition: any, specAlreadyDefined?: boolean) {

    if (specAlreadyDefined != undefined && specAlreadyDefined == false) {
      definition.typespecifics = {};
    }
    definition.typespecifics.hasRepetition = tree.getHasRepetition();

    let alphabet: [any[], number][] = tree.getSet();

    //Export alphabet
    definition.typespecifics.alphabets = new Array();
    alphabet.forEach(element => {
      const temp = new Object();
      temp['alphabet'] = new Array();
      element[0].forEach(el => {
        temp['alphabet'].push(el);
      })
      temp['length'] = element[1];
      definition.typespecifics.alphabets.push(temp);
    })
  }

  importTree(config:any): [any[], number][]{
    return this.importMultiTree(config);
  }

  importMultiTree(config: any): [any[], number][] {
    let alphabets: [any[], number][] = [];
    const alps = config.typespecifics.alphabets;
    for (let i in alps) {
      alphabets.push([alps[i].alphabet, Number(alps[i].length)]);
    }
    return alphabets;
  }


  importTreeOld(config: any): [any[], number] {
    let alphabet: any[] = [];
    const alp = config.typespecifics.alphabet;
    let i;

    for (i in alp) {
      alphabet.push(alp[i]);
    }

    let depth: number = Number(config.typespecifics.depth);
    return [alphabet, depth];
  }

  importHasRepetition(config: any): boolean {
    return config.typespecifics.hasRepetition;
  }

  exportHiddenNodes(hiddenNodes: TreeNode[], definition: any) {
    definition.typespecifics.hiddenNodes = new Array();

    hiddenNodes.forEach(node => {
      const temp = new Object();
      temp['content'] = new Array();
      node.getContent().forEach(elem => {
        temp['content'].push(elem);
      });

      definition.typespecifics.hiddenNodes.push(temp);
    })
  }
  exportMarkedNodes(markedNodes: TreeNode[], definition: any) {
    definition.typespecifics.markedNodes = new Array();

    markedNodes.forEach(node => {
      const temp = new Object();
      temp['content'] = new Array();
      node.getContent().forEach(elem => {
        temp['content'].push(elem);
      });

      definition.typespecifics.markedNodes.push(temp);
    })
  }
  exportDeletedNodes(markedNodes: TreeNode[], definition: any) {
    definition.typespecifics.deletedNodes = new Array();

    markedNodes.forEach(node => {
      const temp = new Object();
      temp['content'] = new Array();
      node.getContent().forEach(elem => {
        temp['content'].push(elem);
      });

      definition.typespecifics.deletedNodes.push(temp);
    })
  }
  exportMultiHiddenNodes(hiddenNodes: MultiSetTreeNode[], definition: any) {
    definition.typespecifics.hiddenNodes = new Array();

    hiddenNodes.forEach(node => {
      const temp = new Object();
      temp['content'] = new Array();
      node.getContent().forEach(elem => {
        temp['content'].push(elem);
      });

      definition.typespecifics.hiddenNodes.push(temp);
    })
  }
  exportMultiHiddenContent(hiddenNodes: any[][], definition: any) {
    definition.typespecifics.hiddenNodes = new Array();

    hiddenNodes.forEach(node => {
      const temp = new Object();
      temp['content'] = node;
      definition.typespecifics.hiddenNodes.push(temp);
    })
  }

  exportMultiMarkedContent(hiddenNodes: any[][], definition: any) {
    definition.typespecifics.markedNodes = new Array();

    hiddenNodes.forEach(node => {
      const temp = new Object();
      temp['content'] = node;
      definition.typespecifics.markedNodes.push(temp);
    })
  }

  exportMultiDeletedContent(hiddenNodes: any[][], definition: any) {
    definition.typespecifics.deletedNodes = new Array();

    hiddenNodes.forEach(node => {
      const temp = new Object();
      temp['content'] = node;
      definition.typespecifics.deletedNodes.push(temp);
    })
  }


  exportSubTreeNode(subNode: MultiSetTreeNode, definition: any) {

    if (subNode == null) {
      return;
    }

    definition.typespecifics.subNodeContent = new Array();
    subNode.getContent().forEach(c => {
      definition.typespecifics.subNodeContent.push(c);
    });
  }

  exportFakeNodes(fakeNodes: TreeNode[], definition: any) {
    definition.typespecifics.fakeNodes = new Array();
    fakeNodes.forEach(node => {
      const temp = new Object();
      temp['content'] = new Array();
      node.getContent().forEach(elem => {
        temp['content'].push(elem);
      });

      definition.typespecifics.fakeNodes.push(temp);
    })
  }

  importTreeType(config: any): any {
    return config.typespecifics.treeType;
  }


  importSubNode(config: any): any[] {
    let res: any[] = [];
    let content = config.typespecifics.subNodeContent;
    let i;

    for (i in content) {
      res.push(content[i]);
    }
    return res;
  }

  /**
   * @returns contents of hidden nodes
   */
  importHiddenNodes(config: any): any[][] {
    const hiddenContents = config.typespecifics.hiddenNodes;
    let res: any[][] = [];
    let i;

    for (i in hiddenContents) {
      let content: any[] = hiddenContents[i].content;
      res.push(content);
    }
    return res;
  }

  /**
   * @returns contents of marked nodes
   */
  importMarkedNodes(config: any): any[][] {
    const markedContents = config.typespecifics.markedNodes;
    let res: any[][] = [];
    let i;

    for (i in markedContents) {
      let content: any[] = markedContents[i].content;
      res.push(content);
    }
    return res;
  }

  importDeletedNodes(config: any): any[][] {
    const deletedContents = config.typespecifics.deletedNodes;
    let res: any[][] = [];
    let i;

    for (i in deletedContents) {
      let content: any[] = deletedContents[i].content;
      res.push(content);
    }
    return res;
  }



  /**
   * @returns contents of fake nodes
   */
  importFakeNodes(config: any): any[][] {
    const hiddenContents = config.typespecifics.fakeNodes;
    let res: any[][] = [];
    let i;

    for (i in hiddenContents) {
      let content: any[] = hiddenContents[i].content;
      res.push(content);
    }
    return res;

  }
}
